import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { Scene } from '@babylonjs/core/scene';
import { SketchPath } from '@kb3d/models/classes/meshes/sketch-node-path';
import { Token } from '@kb3d/models/classes/token';
import { ITrackedClass } from '@kb3d/models/interfaces';
import { KbViewer } from '..';
import { Renderer } from './renderer';

export class PathRenderer extends Renderer<SketchPath, TransformNode> {
    constructor(protected viewer: KbViewer, protected scene: Scene) {
        super(viewer, scene);
    }

    modelToken = Token.SketchPath;

    update3dInternal(node: ITrackedClass<SketchPath>) {}
}
